import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgSingleBed = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 16,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0a1 1 0 0 1 1 1v4a2 2 0 0 1 2 2v5h-1.5l-.5 2h-1l-.5-2h-9L3 14H2l-.5-2H0V7a2 2 0 0 1 2-2V1a1 1 0 0 1 1-1h10Zm1 6H2a1 1 0 0 0-.993.883L1 7v4h14V7a1 1 0 0 0-.883-.993L14 6Zm-1-5H3v4h2V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2h2V1Zm-3 2H6v2h4V3Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgSingleBed;